import SubscriptionForm from './SubscriptionForm';

type Props = {
  text: string;
};

export default function SubscribeCTABlock({ text }: Props) {
  return (
    <section className="bg-secondary py-24 text-white">
      <div className="mx-auto flex max-w-7xl flex-col items-center px-6 text-center lg:flex-row lg:text-left">
        <div className="text-r-3xl mb-8 flex-auto font-bold lg:mb-0 lg:mr-8 lg:w-1/2 ">
          {text}
        </div>
        <div className="lg:w-1/2">
          <SubscriptionForm />
        </div>
      </div>
    </section>
  );
}
